module.exports = __webpack_public_path__ + "static/media/ownershipEcheqsNew.f6f80004.svg";